import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './pages/Layout';
import ScrollToTop from './components/ScrollToTop';
import ChannelIdPreserver from './components/ChannelIdPreserver';
import Home from './pages/Home/index';
import News from './pages/News/index';
import NewsDetail from './pages/NewsDetail/index';
import PublicReport from './pages/PublicReport/index';
import AboutUs from './pages/AboutUs/index';
import Projects from './pages/Project/index';
import ProjectDetail from './pages/ProjectDetail/index';
import ApplyInfo from './pages/ApplyInfo/index';
import PrivacyPolicy from './pages/PrivacyPolicy/index';
import TermsOfService from './pages/TermsOfService/index';
import Register from './pages/Register/index';
import Activate from './pages/Activate/index';
import Login from './pages/Login/index';
import FamilyFriendly from './pages/FamilyFriendly/index';
import FamilyFriendlyOverview from './pages/FamilyFriendly/Overview/index';
import FamilyFriendlyQuestionnaire from './pages/FamilyFriendly/Questionnaire/index';
import FamilyFriendlyCompanyInfo from './pages/FamilyFriendly/CompanyInfo/index';
import FamilyFriendlyPromo from './pages/FamilyFriendlyPromo/index';
import MemberDetail from './pages/MemberDetail/index';
import RegisterSuccess from './pages/RegisterSuccess/index';

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <ChannelIdPreserver />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/public-report" element={<PublicReport />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/apply-info" element={<ApplyInfo />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/register" element={<Register />} />
          <Route path="/activate" element={<Activate />} />
          <Route path="/login" element={<Login />} />
          <Route path="/family-friendly-promo" element={<FamilyFriendlyPromo />} />
          <Route path="/members/:id" element={<MemberDetail />} />
          <Route path="/register-success" element={<RegisterSuccess />} />
          <Route path="/family-friendly" element={<FamilyFriendly />}>
            <Route index element={<FamilyFriendlyOverview />} />
            <Route path="overview" element={<FamilyFriendlyOverview />} />
            <Route path="questionnaire" element={<FamilyFriendlyQuestionnaire />} />
            <Route path="company-info" element={<FamilyFriendlyCompanyInfo />} />
          </Route>
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
